<ng-template #settingsTemplate>
    <app-tool-setting label="Waarden" class="slider-groups">
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.D" label="D"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.H" label="H"></app-range-slider>
        </div>
        <div class="slider-group">
            <app-range-slider [max]="9" [(range)]="rangeModel.T" label="T"></app-range-slider>
            <app-range-slider [max]="9" [(range)]="rangeModel.E" label="E"></app-range-slider>
        </div>
    </app-tool-setting>
</ng-template>
<ng-template #contentTemplate>
    <svg id="Laag_1"
         data-name="Laag 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 192 97.07"
         style="height: 150px"
    >
        <defs>
            <style>.cls-1{fill:#eaf4fb;}.cls-2{fill:#1d1d1b;}.cls-3,.cls-4,.cls-5{fill:none;stroke:#0090c9;}.cls-3{stroke-width:1.5px;}.cls-4{stroke-width:3px;}.cls-5{stroke-width:1.13px;}.cls-6{font-size:28px;font-family:UniversLTStd, Univers LT Std;}</style>
        </defs>
        <title>DBS_DHTE_schema</title>
        <rect class="cls-1"
              y="1.07"
              width="192"
              height="48" />
        <path class="cls-2"
              d="M16.77,15.91h5.85c2.71,0,5.91,0,8.15,2.64a11.63,11.63,0,0,1,2.49,7.64c0,4.37-1.82,7.06-3.36,8.29-2,1.65-4.48,1.65-7.45,1.65H16.77Zm2.8,17.92h2.74c1.93,0,4-.11,5.29-1.12,2.58-1.93,2.66-5.23,2.66-6.41,0-.75-.05-4.2-2-6.3-1.29-1.43-2.91-1.76-5.37-1.76H19.57Z"
              transform="translate(0 -0.93)" />
        <path class="cls-2"
              d="M119,36.13V18.29h-6.78V15.91h16.32v2.38h-6.77V36.13Z"
              transform="translate(0 -0.93)" />
        <path class="cls-2"
              d="M161.89,15.91h12.68v2.38h-9.88v6.3h9.41V27h-9.41v6.72H174.8v2.46H161.89Z"
              transform="translate(0 -0.93)" />
        <path class="cls-2"
              d="M66.72,15.91v8.68h9.6V15.91h2.8V36.13h-2.8V27h-9.6v9.13h-2.8V15.91Z"
              transform="translate(0 -0.93)" />
        <line class="cls-3"
              x1="95.49"
              y1="1.07"
              x2="95.49"
              y2="97.07" />
        <line class="cls-3"
              x1="143.66"
              y1="1.07"
              x2="143.66"
              y2="97.07" />
        <line class="cls-4"
              x1="47.75"
              y1="1.07"
              x2="47.75"
              y2="97.07" />
        <line class="cls-5"
              y1="49.57"
              x2="192"
              y2="49.57" />
        <line class="cls-5"
              y1="0.57"
              x2="192"
              y2="0.57" />
        <text class="cls-6"
              transform="translate(160.22 84.59)">{{rangeModel.E}}</text>
        <text class="cls-6"
              transform="translate(111.22 84.59)">{{rangeModel.T}}</text>
        <text class="cls-6"
              transform="translate(64.22 84.59)">{{rangeModel.H}}</text>
        <text class="cls-6"
              transform="translate(16.22 84.59)">{{rangeModel.D}}</text>
    </svg>
</ng-template>

